import React, {useContext, useRef, useState} from "react";
import {ModalDrawerProps} from "../core/_models";
import {FormDrawer} from "./FormDrawer";

type ModalContextProps = {
    set: (param: any, value: any) => void
    submit: (action: any, modal: any) => void
}

export function ModalDrawer({config, context, inner = false, parentFormId}: ModalDrawerProps) {
    const formContext = useContext(context);

    const {modal, id} = config;

    // Collected values for this modal, kept in a ref so writes don't re-render.
    const valuesRef = useRef<{ [key: string]: any }>({});

    // Stable context object for this modal instance (created once, not per render).
    const [thisModalContext] = useState(() =>
        React.createContext<ModalContextProps | null>(null)
    );

    const submit = async (action: any, modal: any) => {
        if (inner) {
            formContext.submit({action}, {modal, formId: parentFormId});
        } else {
            formContext.submit({action}, modal);
        }
    }

    return (
        <thisModalContext.Provider value={{
            set: (param: any, value: any) => {
                valuesRef.current[param] = value
            },
            submit,
        }}>
            <FormDrawer config={config} context={thisModalContext} isModal={true}/>

            {modal != null &&
                <ModalDrawer config={modal} context={thisModalContext} inner={true} parentFormId={id}/>}
        </thisModalContext.Provider>
    )
}
